export const ActivationLoginTranslations = {
  es: {
    texts: {
      h2: 'Iniciar sesión',
      h1: '¡YA ESTÁ ACTIVA TU CUENTA!',
      h3: 'Empieza a cargar y firmar tus documentos',
    },
    inputs: {
      inputPlaceholder1: 'Certificado (.cer)',
      inputPlaceholder2: 'Llave privada (.key)',
      inputPlaceholder3: 'Clave privada (contraseña)',
    },
    buttons: {
      button1: 'Ingresar',
    },
    notifications: {
      notifTitle1: 'Advertencia',
      notifBody1: '', // TODO: translate response
      notifTitle2: 'Advertencia',
      notifBody2: 'Credenciales inválidas',
      notifTitle3: 'Advertencia',
      notifBody3: '', // TODO: translate response
    },
  },
  en: {
    texts: {
      h2: 'Login',
      h1: 'YOUR ACCOUNT IS ACTIVE!',
      h3: 'Start uploading and digitally sign your documents',
    },
    inputs: {
      inputPlaceholder1: 'Certificate (.cer)',
      inputPlaceholder2: 'Private key (.key)',
      inputPlaceholder3: 'Private code (password)',
    },
    buttons: {
      button1: 'Login',
    },
    notifications: {
      notifTitle1: 'Warning',
      notifBody1: '', // TODO: translate response
      notifTitle2: 'Warning',
      notifBody2: 'Invalid credentials',
      notifTitle3: 'Warning',
    },
  },
};
